export default __webpack_public_path__ + "static/media/slide_0.5d1af41c.jpeg";